import { render, staticRenderFns } from "./TipoJuicios.vue?vue&type=template&id=e235cec2"
import script from "./TipoJuicios.vue?vue&type=script&lang=js"
export * from "./TipoJuicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports